<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.relatedPartyInfo">
      <div class="pa-3 content-wrapper">
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="formModel.applicantCasePartyId"
          :label="local.caseRelatedRequest.relatedPartyInfo"
          :items="prosecutorOrDefendantCaseParties"
          item-value="casePartyId"
          item-text="name"
          validates="required"
          :disabled="casePartiesSelectboxDisabled"
          @change="selectedCasePartySocialIdChanged"
        ></naj-input>
        <h6 class="request-applicant-type-message">
          {{ local.caseRelatedRequest.removeAgentFromCaseRequest.chooseApplicantToShowAgentMessage }}
        </h6>
      </div>
    </naj-box>

    <naj-box :title="local.caseRelatedRequest.removeAgentFromCaseRequest.title">
      <v-row>
        <v-col cols="12">
          <div>
            <h5 class="mb-3">
              {{ local.caseRelatedRequest.removeAgentFromCaseRequest.agentToDrop }} <span style="color:red">*</span>
            </h5>
            <naj-data-table
              no-header
              disable-items-per-page
              :headers="agentsHeaders"
              :items="agentsListData"
              :no-margin-bottom="false"
              :show-select="true"
              @input="selectionChange"
            >
            </naj-data-table>
          </div>
        </v-col>
      </v-row>
    </naj-box>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, casePartyRoleEnum, casePartyStatus } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'RemoveAgentFromCaseRequest',
  inject: ['$validator'],
  components: {},
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      caseParties: [],
      caseRepresentatives: [],
      isLoggedInUserExistsAsCaseParty: false,
      userCasePartyRoleInCase: {},
      agentsListData: [],
      agentsHeaders: [
        {
          value: 'fullName',
          text: 'اسم الممثل/الوكيل',
        },
        {
          value: 'refrenceNumber',
          text: 'رقم مستند التمثيل',
        },
      ],
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    casePartiesSelectboxDisabled() {
      return this.isViewMode || (this.formModel.applicantCasePartyId && this.isLoggedInUserExistsAsCaseParty);
    },
    prosecutorOrDefendantCaseParties() {
      return this.caseParties;
    },
  },
  watch: {},
  mounted() {
    if (this.formModel) {
      this.readCurrentUserInfo();
    }

    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    Promise.all([
      this.getCaseRequestApplicants(params),
      this.getUserCasePartyRoleInCase(params),
      this.getCaseRepresentatives(params),
    ])
      .then((res) => {
        this.caseParties = (!this.isViewMode ? res[0].data.requestApplicants : [...res[0].data.prosecutors, ...res[0].data.defendants])
          .filter(cp => !cp.casePartyStatusId || cp.casePartyStatusId == casePartyStatus.active);
        this.userCasePartyRoleInCase = res[1].data;
        this.caseRepresentatives = res[2].data.personParticipantInformation.filter(cp => !cp.casePartyStatusId || cp.casePartyStatusId == casePartyStatus.active);

        this.setRelatedPartyAsRequestApplicant();
      })
      .catch(err => this.toaster.error(err.message))
      .finally(() => (this.loading = false));

  },
  created() {
  },
  methods: {
    ...mapActions([
      'getCaseRequestApplicants',
      'getCaseRepresentatives',
      'getUserCasePartyRoleInCase',
    ]),
    selectedCasePartySocialIdChanged() {
      const selectedApplicantCaseParty = (this.caseParties || []).find(cr => cr.casePartyId == this.formModel.applicantCasePartyId) || {};
      this.agentsListData = (this.caseRepresentatives || []).filter(cr => cr.relatedPartyId == selectedApplicantCaseParty.casePartyId);
    },
    selectionChange(selections) {
      const mapped = this.mapRespondent(selections);
      this.$set(this.formModel, 'Respondent', mapped);
    },

    mapRespondent(selections) {
      const mappedSelections = (selections || []).map((x) => {
        return {
          socialID: x.socialID,
          partyId: x.id,
          fullName: x.fullName,
          roleInCaseName: x.partyRole,
          relatedPartyId: x.relatedPartyId,
          referanceNumber: x.refrenceNumber,
          wekalaTypeId: x.attorneyTypeId,
          refrenceYear: x.refrenceYear,
        };
      });

      return mappedSelections;
    },
    setRelatedPartyAsRequestApplicant() {
      const selectedParty = this.prosecutorOrDefendantCaseParties.find(cp => cp.partyId == this.userCasePartyRoleInCase.partyId);
      if (selectedParty) {
        this.isLoggedInUserExistsAsCaseParty = true;
        this.$set(this.formModel, 'applicantCasePartyId', this.formModel.applicantCasePartyId || selectedParty.casePartyId);
        this.selectedCasePartySocialIdChanged();
      }
    },

    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.request-applicant-type-message {
  color: #2d8cf0;
}
</style>